import styled from 'styled-components';

export const TableHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) =>
    props.flexJustify === 'between' ? 'space-between' : 'flex-end'};

  margin-bottom: 18px;

  .ant-breadcrumb-link a {
    &:hover {
      color: #f49b1a;
    }
  }
`;
